import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import { AWAIT, LOCAL_ACTIONS } from "../agent/agentContract";

const DECISION_AWAITS = [AWAIT.CTA, AWAIT.QUICK_REPLY, AWAIT.CONFIRMATION, AWAIT.QUESTION_FORM];

/**
 * The turn's next steps as one-click buttons in the thread, right under the
 * answer they follow. (They used to float over the composer, where they hid
 * the card being read and outlived the turn they belonged to.)
 */
const NextSteps = observer(() => {
  const history = useHistory();
  const messages = copilotStore.messages || [];
  const last = messages[messages.length - 1];
  const items = copilotStore.suggestions || [];
  if (!items.length || copilotStore.streaming || !last || last.role !== "assistant") return null;
  // A question in the answer is the next step already; two sets of buttons compete.
  const openQuestion = (last.blocks || []).some(b => b.type === "quick_replies" && !b.selectedValue);
  if (openQuestion || DECISION_AWAITS.includes(copilotStore.awaiting) || copilotStore.isOnboarding()) return null;

  return (
    <div className="copilotNextSteps">
      {items.map(item => (
        <button
          type="button"
          key={`${item.kind}_${item.label}`}
          className="copilotCtaChips__chip"
          onClick={() => {
            const handled = copilotStore.applySuggestion(item);
            if (!handled && item.actionId === LOCAL_ACTIONS.NAVIGATE && item.path) history.push(item.path);
          }}
        >
          {item.kind === "action" && <i className="material-icons-outlined">{item.icon || "arrow_forward"}</i>}
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
});

export default NextSteps;
